import { Component, Input } from '@angular/core';

@Component({
  selector: 'ubc-lazy-image',
  standalone: true,
  imports: [],
  templateUrl: './lazy-image.component.html',
  styleUrl: './lazy-image.component.scss'
})
export class LazyImageComponent {
  @Input() src: string;
  @Input() alt: string;

  onError() {
    this.src = 'assets/placeholder-image.jpg'; // Path to a placeholder image
  }
}
